import * as types from "./../types";

const initState = {  isSubmitedSuccess: false };
const PartnerReducer = (state = initState, action) => {
    switch (action.type) {
        case types.CAD_ADDRESS_CONFIRMED:
            return {
                ...state,
                isSubmitedSuccess:action.payload?.isSubmitedSuccess,
               
            };
        case types.PARTNER_INGESTION_DATA:
            return {
                ...state,
                isSubmitedSuccess:action.payload?.isSubmitedSuccess,
                hsToken:action.payload?.hsToken,
            };
        case types.SAVE_PARTNER_HANDOFF_DATA:
             return {
                ...state,
                isSubmitedSuccess:action.payload?.isSubmitedSuccess,
                partnerEvents:action.payload,
            };
        case types.UPDATE_CURRENT_PARTNER_STATE:
            return {
                ...state,
                isSaved: action.payload.isSaved,
                currentAction: action.payload.currentAction,
                screenName: action.payload.screenName || state.screenName,
                isSubmited: action.payload.isSubmited,
                isSubmitedSuccess: action.payload.isSubmitedSuccess,
                loading: action.payload.loading,
            };
        default:
            return state;
    }
};

export default PartnerReducer;